import classnames from 'classnames/bind';
import { useContext } from 'react';
import { useFloatingTree, useListItem, useMergeRefs } from '@floating-ui/react';
import { Icon, IconSize } from 'app/components/core/Icon';
import { MenuContext } from './MenuContext.jsx';
import * as styles from './ComposableMenu.css';

const cx = classnames.bind(styles);

function DefaultMenuItem({ icon, tag, className, children, ref, ...props }) {
    const classList = cx('menu-item', className);

    return (
        <button type="button" className={classList} ref={ref} {...props}>
            {icon && (
                <Icon className={cx('icon')} variant={icon} size={IconSize.EXTRA_SMALL} inline />
            )}
            <span className={cx('label')}>
                {children}
                {tag ? <span className={cx('tag')}>{tag}</span> : null}
            </span>
        </button>
    );
}

export function MenuItem({ as: Component, label, disabled, ref, ...props }) {
    const menu = useContext(MenuContext);
    const item = useListItem({ label: disabled ? null : label });
    const tree = useFloatingTree();
    const isActive = item.index === menu.activeIndex;

    const itemProps = menu.getItemProps({
        ...props,
        ref: useMergeRefs([item.ref, ref]),
        role: 'menuitem',
        tabIndex: isActive ? 0 : -1,
        disabled,
        onClick(event) {
            props.onClick?.(event);
            tree?.events.emit('click');
        },
        onFocus(event) {
            props.onFocus?.(event);
        }
    });

    if (Component) {
        return (
            <div>
                <Component {...itemProps}>{label}</Component>
            </div>
        );
    }

    return <DefaultMenuItem {...itemProps}>{label}</DefaultMenuItem>;
}
